<style scoped lang="sass">
.assign-point-values-cutoffs
  font-size: 0.75rem
  td
    text-align: center
    padding: 0.2rem
.scoring-method-option-description
  font-size: 12px
</style>
<template>
  <div>
    <div class="input-group">
      <label>ASSIGN POINT VALUES</label>
      <div v-if="errors.assignValues">{{errors.assignValues}}</div>
      <table class="assign-point-values-cutoffs">
        <tbody>
          <tr v-for="(start, index) in starts">
            <td>{{ordinality(start)}}</td>
            <td>
              <span v-if="cutoffEndOptions({index}).length !== 1">-</span>
</td>
            <td>
              <span v-if="cutoffEndOptions({index}).length !== 1">
                <pinhigh-select
                    :options="cutoffEndOptions({index})"
                    v-model="scoringMethodConfigCutoffHashCutoffs[index].cutoff"
                    :on-select="setCutoffHashCutoffCutoff({index})"
                    :block="false"
                    size="small"
                    >
                      <template slot="label" slot-scope="props">{{ordinality(props.option)}}</template>
                </pinhigh-select>
                place
              </span>
            </td>
            <td>
              worth
              <pinhigh-select
                  :options="valueOptions"
                  v-model="scoringMethodConfigCutoffHashCutoffs[index].value"
                  :on-select="setCutoffHashCutoffValue({index})"
                  :block="false"
                  size="small"
                  ></pinhigh-select>
              <i v-if="scoringMethodConfigCutoffHashCutoffs.length > 1" @click.prevent="removeCutoff({index})">remove</i>
            </td>
          </tr>
        </tbody>
      </table>
      <div>
        <i v-if="scoringMethodConfigCutoffHashCutoffs.length < 20" @click.prevent="addCutoff()">add</i>
      </div>
      <label>ALL OTHERS MAKING THE CUT WORTH</label>
      <pinhigh-select
          :options="valueOptions"
          v-model="scoringMethodConfigCutoffHashDefault"
          ></pinhigh-select>
    </div>
    <div class="input-group">
      <label>SCORING OPTIONS</label>
      <div v-for="scoringMethodOption in scoringMethodOptions">
        <input type="checkbox" @click.prevent="toggleScoringMethodConfigOption(scoringMethodOption)" :checked="scoringMethodConfigOptionsByName[scoringMethodOption.name]">
        {{scoringMethodOption.name}}
        <span v-if="scoringMethodConfigOptionsByName[scoringMethodOption.name]">
          <pinhigh-select
              :options="valueOptions"
              v-model="scoringMethodConfigOptionsByName[scoringMethodOption.name].value"
              :on-select="setScoringMethodConfigOptionValue(scoringMethodOption.name)"
              :block="false"
              size="small"
              ></pinhigh-select>
          pts
        </span>
        <div class="scoring-method-option-description">{{scoringMethodOption.description}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import numberToWords from 'number-to-words';

export default {
  name: 'AssignValues',
  props: {
    errors: Object
  },
  data() {
    return {
      scoringMethodOptions: [
        {
          name: 'Low round',
          description: 'Points awarded each time a pick shoots a low round for a day',
          defaultValue: 1
        },
        {
          name: 'All picks make cut',
          description: 'Points awarded if all picks make cut and finish or get MDF',
          defaultValue: 1
        }
      ],
      cutoffLimit: 200,
      valueLimit: 100
    };
  },
  computed: {
    pool() {
      return this.$store.getters['poolForm/pool'];
    },
    scoringMethodConfig() {
      return this.pool.scoring_method_config;
    },
    scoringMethodConfigCutoffHashCutoffs() {
      return this.scoringMethodConfig.cutoffHash.cutoffs;
    },
    scoringMethodConfigCutoffHashDefault: {
      get(){ return this.scoringMethodConfig.cutoffHash.default; },
      set(value){ this.$store.dispatch('poolForm/setScoringMethodConfigCutoffHashDefault', value); }
    },
    scoringMethodConfigOptionsByName() {
      return this.scoringMethodConfig.options.reduce((memo,option) => (memo[option.name] = option, memo), {});
    },
    starts() {
      const cutoffs = this.scoringMethodConfigCutoffHashCutoffs || [];
      return cutoffs.map(({cutoff}, index) => {
        return cutoffs[index - 1] ? parseInt(cutoffs[index - 1].cutoff) + 1 : 1;
      });
    },
    valueOptions() {
      return Array.from({length: this.valueLimit}, (value, key) => key + 1);
    }
  },
  methods: {
    setCutoffHashCutoffCutoff({index}) {
      return value => this.$store.dispatch('poolForm/setScoringMethodConfigCutoffHashCutoffCutoff', [index, value]);
    },
    setCutoffHashCutoffValue({index}) {
      return value => this.$store.dispatch('poolForm/setScoringMethodConfigCutoffHashCutoffValue', [index, value]);
    },
    cutoffEndOptions({index}) {
      const start = this.scoringMethodConfigCutoffHashCutoffs[index - 1] ?
        parseInt(this.scoringMethodConfigCutoffHashCutoffs[index - 1].cutoff) + 1 :
        1;
      return this.scoringMethodConfigCutoffHashCutoffs[index + 1] ?
        Array.from({length: (parseInt(this.scoringMethodConfigCutoffHashCutoffs[index + 1].cutoff) - start)}, (value, key) => start + key) :
        Array.from({length: (this.cutoffLimit + 1 - start)}, (value, key) => start + key);
    },
    removeCutoff({index}) {
      this.$store.dispatch('poolForm/removeScoringMethodConfigCutoffHashCutoff', index);
    },
    addCutoff() {
      const lastCutoff = this.scoringMethodConfigCutoffHashCutoffs[this.scoringMethodConfigCutoffHashCutoffs.length - 1].cutoff;
      if (parseInt(lastCutoff) < this.cutoffLimit) {
        this.$store.dispatch('poolForm/addScoringMethodConfigCutoffHashCutoff', 
          {cutoff: parseInt(lastCutoff) + Math.ceil((this.cutoffLimit - parseInt(lastCutoff)) / 4), value: 10}
        );
      }
    },
    ordinality(number) {
      return numberToWords.toOrdinal(number);
    },
    toggleScoringMethodConfigOption({name, defaultValue}) {
      if (this.scoringMethodConfigOptionsByName[name]) {
        this.$store.dispatch('poolForm/removeScoringMethodConfigOption', name);
      } else {
        this.$store.dispatch('poolForm/addScoringMethodConfigOption', {name, value: defaultValue});
      }
    },
    setScoringMethodConfigOptionValue(name) {
      return value => this.$store.dispatch('poolForm/setScoringMethodConfigOptionValue', [name, value]);
    }
  }
};
</script>
